import api from "services/api";

// Get active leave types (for dropdown)
export const getActiveLeaveTypes = async () => {
  return api.get("/v1/api/leave-types/active");
};

// Apply for leave
export const applyLeave = async (leaveData) => {
  return api.post("/v1/api/leave/apply", leaveData);
};

// Cancel a leave
export const cancelLeave = async (leaveId) => {
  return api.put(`/v1/api/leave-cancel/${leaveId}`);
};

// Get leave summary & balances for the employee
export const getLeaveSummary = async () => {
  return api.get("/v1/api/leave-summary");
};

// Get employee's submitted leave requests
export const getMyLeaves = async (params = {}) => {
  return api.get("/v1/api/my-leaves", { params });
};
